import { render } from "./BienImmoDossier.vue?vue&type=template&id=f4661634"
import script from "./BienImmoDossier.vue?vue&type=script&lang=js"
export * from "./BienImmoDossier.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__